<app-header></app-header>

<div class="flex-grow-1 overflow-auto">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
